module.exports = __webpack_public_path__ + "static/media/e-hero.408434b7.png";